import React, { useState, useEffect } from 'react';
import { isInstagramBrowser } from '../utils/browserDetection';

const InstagramBrowserModal = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Only show modal in Instagram browser
    if (isInstagramBrowser()) {
      // Check if user has already seen this modal in this session
      const hasSeenModal = sessionStorage.getItem('instagramModalSeen');
      if (!hasSeenModal) {
        setIsVisible(true);
      }
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    sessionStorage.setItem('instagramModalSeen', 'true');
  };

  const handleCopyLink = () => {
    const currentUrl = window.location.href;
    navigator.clipboard.writeText(currentUrl).then(() => {
      alert('لینک کپی شد! حالا آن را در مرورگر اصلی خود باز کنید.');
    }).catch(() => {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = currentUrl;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      alert('لینک کپی شد! حالا آن را در مرورگر اصلی خود باز کنید.');
    });
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-sm w-full">
        {/* Header */}
        <div className="bg-gradient-to-r from-purple-500 to-pink-500 text-white p-3 rounded-t-lg">
          <div className="flex items-center justify-between">
            <h2 className="text-base font-bold">📱 برای تجربه بهتر</h2>
            <button
              onClick={handleClose}
              className="text-white hover:text-gray-200 text-lg font-bold"
            >
              ×
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-3">
          <div className="text-center mb-3">
            <p className="text-gray-700 text-xs">
              شما در مرورگر اینستاگرام هستید. برای دسترسی کامل به دوربین، از مرورگر اصلی گوشی استفاده کنید.
            </p>
          </div>

          {/* Quick Instructions */}
          <div className="mb-3">
            <div className="bg-gray-50 p-2 rounded-lg text-xs">
              <p className="text-gray-700 font-medium mb-1">🍎 آیفون:</p>
              <p className="text-gray-600">سه نقطه (⋯) → "Open in Safari"</p>
              
              <p className="text-gray-700 font-medium mb-1 mt-2">🤖 اندروید:</p>
              <p className="text-gray-600">سه نقطه (⋯) → "Open in Browser"</p>
            </div>
          </div>

          {/* Benefits */}
          <div className="mb-3">
            <div className="bg-green-50 p-2 rounded-lg text-xs">
              <p className="text-gray-700 font-medium mb-1">✨ مزایا:</p>
              <p className="text-gray-600">دسترسی کامل به دوربین • عملکرد بهتر</p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="bg-gray-100 p-3 rounded-b-lg">
          <div className="flex gap-2">
            <button
              onClick={handleClose}
              className="flex-1 bg-gray-500 text-white py-2 px-3 rounded-lg hover:bg-gray-600 transition-colors text-xs"
            >
              متوجه شدم
            </button>
            <button
              onClick={handleCopyLink}
              className="flex-1 bg-blue-500 text-white py-2 px-3 rounded-lg hover:bg-blue-600 transition-colors text-xs"
            >
              کپی لینک
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstagramBrowserModal;
